/**
 * Theme handling.
 *
 * The theme lives on <html data-theme="…">, which is what App.css switches its
 * token block on. index.html applies the stored value before first paint; this
 * module only handles changes made after the app has mounted.
 */

const STORAGE_KEY = 'leads-scanner-theme';

// Cycle order. 'dark' is the neutral black theme; 'midnight' is the navy one.
export const THEMES = ['light', 'dark', 'midnight'];

export const THEME_LABELS = { light: 'Light', dark: 'Dark', midnight: 'Midnight' };

/** The theme that follows `theme` when the toggle is pressed. */
export function nextTheme(theme) {
  return THEMES[(THEMES.indexOf(theme) + 1) % THEMES.length];
}

/** Current theme, read from the DOM so it can never disagree with what is shown. */
export function getTheme() {
  const attr = document.documentElement.getAttribute('data-theme');
  return THEMES.includes(attr) ? attr : 'dark';
}

export function setTheme(theme) {
  const next = THEMES.includes(theme) ? theme : 'dark';
  document.documentElement.setAttribute('data-theme', next);

  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    // Private browsing or a full quota. The theme still applies for this
    // session; only persistence is lost, which is not worth an error.
  }

  return next;
}

export function toggleTheme() {
  return setTheme(nextTheme(getTheme()));
}
